<template>
    <div
            class="modal fade"
            id="sys_see_ammeterrecord_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="myModalLabel">电表查表记录</h4>
                </div>
                <!-- modal-body-->
                <div class="modal-body">
                    <table id="atptable" class="table table-hover table-striped">
                        <thead>
                        <tr>
                            <th>电表编号</th>
                            <th>查表日期</th>
                            <th>电表读数</th>
                            <th>电表照片</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in ammeterInfo" :key="index">
                            <td>{{item.ammeter_numbering}}</td>
                            <td>{{item.create_datetime}}</td>
                            <td>{{item.amount}}</td>
                            <td>
                                <img
                                        :src="item.picture_ammeter"
                                        @click="enlarge(item.picture_ammeter)"
                                        alt
                                        style="width:100px;height:100px;"
                                />
                            </td>
                        </tr>
                        <tr v-if="ammeterInfo.length>0"></tr>
                        <tr class="no-records-found" v-else>
                            <td colspan="8">没有找到匹配的记录</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <!-- modal-footer -->
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
                    <!-- <button type="button" class="btn btn-primary" @click="change">xiug</button> -->
                </div>
            </div>
        </div>
        <img class="imgLayer" v-show="imgShow" :src="imgSrc" alt @click="narrow"/>
    </div>
</template>
<script>
  export default {
    data () {
      return {
        ammeterInfo: [],
        imgSrc: '', // 被放大图片的路径
        imgShow: false
      }
    },
    props: ['msgStationid'],
    mounted: function () {
      var self = this
    },
    methods: {
      getData: function () {
        var self = this
        self.ammeterInfo = []
        // 获取所有的电表 根据电表编号请求查表记录接口
        self.global.axiosGet(
          self,
          'station/' + self.msgStationid + '/ammeters/',
          function (res) {
            self.getammeternumber(res, 0, res.length)
          }
        )
      },
      getammeternumber: function (res, i, length) {
        var self = this
        if (length == 0) return
        var ammeter_numbering = res[i].ammeter_numbering
        var ammeterInfo = self.ammeterInfo
        // 获取最近查表记录
        self.global.axiosGet(self, 'ammeter/' + res[i].id + '/records/', function (
          resp
        ) {
          console.log(resp)
          for (var m = 0; m < resp.length; m++) {
            resp[m].picture_ammeter = self.global.ossHost + resp[m].photo_path
            resp[m].ammeter_numbering = ammeter_numbering
            ammeterInfo.push(resp[m])
          }

          self.ammeterInfo = ammeterInfo
          if (++i < length) {
            self.getammeternumber(res, i, length)
          } else {
            console.log(self.ammeterInfo)
          }
        })
      },
      // 图片放大
      enlarge: function (src) {
        console.log(src)
        var self = this
        self.imgShow = true
        self.imgSrc = src
      },
      // 图片缩小
      narrow: function () {
        var self = this
        self.imgShow = false
      }
    }
  }
</script>
<style scoped>
    .imgLayer {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 999;
        max-width: 100%;
        max-height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/stationmanager/seeammeterrecord.vue